import * as React from 'react'
import { Fragment, useMemo, useState } from 'react'
import cx from 'classnames'
import { useIntl } from 'react-intl'

import { Icon } from '@metrisk/react_metrisk-components'

import { checkPasswordCondition, passwordValidationConditions } from '@app/utils/validation'

const strengths = {
  weak: 4,
  average: 7,
  strong: 9,
  requirement: 12,
}

const PasswordStrengthMeter = ({ value, isFocused }: any) => {
  const intl = useIntl()
  const messages: any = {
    lowercase: intl.formatMessage({ defaultMessage: 'At least 1 lowercase character' }),
    uppercase: intl.formatMessage({ defaultMessage: 'At least 1 uppercase character' }),
    number: intl.formatMessage({ defaultMessage: 'At least 1 number' }),
    specialCharacter: intl.formatMessage({ defaultMessage: 'At least 1 special character' }),
    length: intl.formatMessage({ defaultMessage: 'At least 8 characters, up to 99 characters' }),
    validCharacters: intl.formatMessage({ defaultMessage: 'Only contains valid characters' }),
  }
  const [issues, setIssues] = useState<string[]>([])
  const strength = useMemo((): number => {
    const runIssues: string[] = []
    let strength = Object.keys(passwordValidationConditions).reduce((acc, key: string) => {
      const condition = passwordValidationConditions[key]

      if (value) {
        if (checkPasswordCondition(value, condition)) return acc + 2
      }

      runIssues.push(key)

      return acc
    }, 0)

    setIssues(runIssues)

    return strength
  }, [value])
  const showGuidelines = value && issues.length > 0

  return (
    <Fragment>
      <div className={cx('password-strength', { 'password-strength--focused': isFocused })}>
        <div
          className={cx('password-strength__meter', { 'password-strength__meter--with-guidelines': showGuidelines })}
        >
          <span
            className={cx('password-strength__bar', {
              'password-strength__bar--weak': strength >= strengths.weak,
              'password-strength__bar--average': strength >= strengths.average,
              'password-strength__bar--strong': strength >= strengths.strong,
              'password-strength__bar--requirement': strength >= strengths.requirement,
            })}
          ></span>
        </div>
      </div>
      <div
        className={cx('password-strength__guidelines', {
          'password-strength__guidelines--active': showGuidelines,
        })}
      >
        {Object.keys(passwordValidationConditions).map((key) => (
          <div key={key} className="password-strength__requirement">
            <Icon
              name={issues.indexOf(key) === -1 ? 'tick' : 'cross'}
              colour={issues.indexOf(key) === -1 ? 'Success' : 'Error'}
            />
            {messages[key]}
          </div>
        ))}
      </div>
    </Fragment>
  )
}

export default PasswordStrengthMeter
